export default {
  /**
   * Array of strings or objects
   */
  options: {
    type: Array,
    default: () => ([])
  },

  /**
   * The input name.
   */
  name: {
    type: String,
    default: 'radioGroup'
  },

  trackBy: {
    type: String,
    required: true
  },

  displayBy: {
    type: String,
    required: true
  },

  /**
   * Number of columns
   */
  columns: {
    type: Number,
    default: 1
  },

  /**
   * Selected option's value
   */
  value: {
    type: Array,
    default: () => []
  },

  /**
   * Set hidden native checkboxes inputs for native forms compatibility.
   */
  nativeCompatible: Boolean,

  /**
   * Bind values only by track-by fields on options items
   */
  bindTrackBy: Boolean,

  /**
   * Show selected list component
   */
  showSelectList: Boolean,

  /**
   * Disables all options
   */
  disabled: Boolean
}
